import type { ProcessingState } from "@redux/state/shared-types";
import {
  editAndApproveExternalProviderBatchRequest,
  resetEditAndApproveExternalProviderBatchRequest,
} from "./edit-and-approve-external-provider-batch-request";
import { createReducer } from "@reduxjs/toolkit";

const initialState: ProcessingState = { processing: "idle" };

export const editAndApproveExternalProviderBatchRequestReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(editAndApproveExternalProviderBatchRequest.fulfilled, state => {
      return {
        ...state,
        processing: "success",
      };
    })
    .addCase(editAndApproveExternalProviderBatchRequest.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(editAndApproveExternalProviderBatchRequest.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetEditAndApproveExternalProviderBatchRequest, () => {
    return initialState;
  });
});
